<div class="card position-relaitve"
  [ngClass]="(!productData.productInventoryCount && utils.getUserPicode() && productData.isEshop)?'setBackground':''">
  <div id="wishlistShare" *ngIf="!recommendedSol">
    <span>
      <img (click)="openShareDialog(productData.productGuid,productData.productName)" class="shareIcon"
       loading="lazy" [src]="environment?.blobUrl+'/assets/images/product-listing/pdpShare.svg'" alt="Share Icon | Luminous">
    </span>
  </div>
  <mat-checkbox [ngClass]="{'disabled cursorNotAllowd': !isChecked && utils.isCheckedLimit}"
    [disabled]="!isChecked && utils.isCheckedLimit" [checked]="isChecked"
    (change)="onCheckboxClick(productData.productGuid,$event.checked)" *ngIf="isCompare"></mat-checkbox>
  <a role="button" (click)="triggerSelectEvent()" [routerLink]="getPDPRoute(productData.productGuid,productData.productName)">
    <div class="badgeContainer" *ngIf="!recommendedSol && productData.isEshop && !isCompare">
      <span class="feature"
        [hidden]="tagData.tagText == 'Out of stock' || (!productData.productInventoryCount && utils.getUserPicode())"
        *ngFor="let tagData of productData.productTags"
        [ngStyle]="{'background-color':tagData.tagBackgroundcolor,'color':tagData.tagTextColor}">
        {{tagData.tagText}}
      </span>
      <span *ngIf="!productData.productInventoryCount && utils.getUserPicode()" class="outOfStock m-0">Out of
        Stock</span>
    </div>


    <div class="wrapper" *ngIf="slideData.length">
      <div class="productimgWrap" *ngFor="let slide of slideData">
        <img class="productImg" [ngClass]="{'carouselCover':!productData.productInventoryCount}"  loading="lazy" [src]="slide.image"
          [alt]="slide.altTag">
      </div>

    </div>


    <div class="text-wrap text-center">
      <h2 class="text-transform-none">
        {{productData.productName|truncateStr:[110]}}
        <ng-container *ngIf="offerText && productData.productName === 'AB18060'">(3 Hours)</ng-container>
        <ng-container *ngIf="offerText && productData.productName === 'AB24060'">(4 Hours)</ng-container>
        <ng-container *ngIf="offerText && productData.productName === 'AB30060'">(5 Hours)</ng-container>
        <ng-container *ngIf="offerText && productData.productName === 'AB36060'">(6 Hours)</ng-container>
      </h2>
      <span
        id="storePrice">₹{{(productData.productDiscountedPrice?productData.productDiscountedPrice:productData.productPrice)
        | number:'1.2-2'}}</span><span class="disclaimer">(Inclusive of all taxes)</span>
      <span class="offerText" *ngIf="offerText">{{ offerText }}</span>
      <div class="price-off-wrap" *ngIf="productData.productDiscountedPrice && utils.getUserPicode()">
        <span id="orignalPrice">₹{{productData.productPrice | number:'1.2-2'}}</span>
        <span>
          Save ₹{{productData.productPrice - productData.productDiscountedPrice | number:'1.2-2'}}
          ({{productData.productDiscountedPricePercentage}}%)
        </span>
      </div>
      <div id="priceDetails">
        <span>{{!recommendedSol ? 'View Details' : 'Learn More'}} <img  loading="lazy" [src]="environment?.blobUrl+'/assets/icons/carbon_chevron-sort-down.svg'"
            alt="Right Arrow | Luminous"></span>
      </div>

    </div>

  </a>
</div>
